import React, { useEffect, useState } from "react";
import { GetLocalStorageParsed } from "../../Utils/Utils";
import { useLanguage } from "../LanguageProvider/LanguageProvider ";
import Dashboard from "../../pages/Dashboard/Dashboard";
import { saveAs } from "file-saver"; // Import file-saver
import { useLocation, useNavigate } from "react-router-dom";
import { BsChevronLeft } from "react-icons/bs";

const OldDocumentView = () => {
  const userDetail = GetLocalStorageParsed("userDetail");
  const { language } = useLanguage();
  const location = useLocation();
  const [categoryFileData, setCategoryFileData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!userDetail) {
      navigate("/"); // Redirect if user is not authenticated
    } else {
      if (location?.state && location?.state?.fileData) {
        setCategoryFileData(location?.state?.fileData);
      }
    }
  }, [location?.state, userDetail]);

  // Function to trigger file download
  const handleDownload = (filePath, fileName) => {
    fetch(filePath)
      .then(response => response.blob())  // Convert to Blob
      .then(blob => saveAs(blob, fileName)); // Save as a file
  };

  return (
    <Dashboard
      first={language ? "होम" : "Home"}
      second={language ? "पुराने दस्तावेज़" : "Old Documents"}
      head={language ? "पुराने दस्तावेज़" : "Old Documents"}
    >
      <>
        <div className="aod-bottom">
          <div className="page_heading">
            <h5>{language ? "पुराने दस्तावेज़" : "Old Documents"}</h5>
          </div>
          <div className="mb-2">
            <button
              className="btn btn-green-view fs-6 px-3"
              onClick={() => {
                  navigate(`/old-documents`);
              }}
            >
              <BsChevronLeft /> Back
            </button>
          </div>
          <div className="row">
            <div className="reciept-table table-responsive mt-2">
              <table
                className="table table mb-0 dataTable transaction_table"
                id="receipt_table"
                role="grid"
              >
                <thead className="">
                  <tr role="row">
                    <th>{language ? "क्रम संख्या" : "S.No"}</th>
                    <th>{language ? "फ़ाइल का नाम" : "File Name"}</th>
                    <th>{language ? "कार्रवाई" : "Action"}</th>
                  </tr>
                </thead>
                <tbody>
                  {categoryFileData?.length > 0 ? (
                    categoryFileData?.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.name}</td>
                        <td>
                          {item.path ? (
                            <button
                              className="btn btn-green-view"
                              onClick={(e) => {
                                e.preventDefault();
                                handleDownload(item.path, item.name); // Trigger file download
                              }}
                            >
                              {language ? "डाउनलोड करना" : "Download"}
                            </button>
                          ) : (
                            "--"
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3">
                        {language
                          ? "कोई दस्तावेज़ नहीं पाया गया"
                          : "No documents found"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </>
    </Dashboard>
  );
};

export default OldDocumentView;
